<template>
    <div class="py-3">
        <placeholder size="sm" :width="3"/>
        <placeholder size="sm" :width="3"/>
        <placeholder size="sm" :width="3"/>
        <placeholder size="sm" :width="3"/>
        <placeholder size="sm" :width="3"/>
        <placeholder size="sm" :width="3"/>
    </div>
</template>

<script type="text/javascript">
    import CommonComponents from '@/components/Common.vue';

    export default {
        components: {
            ...CommonComponents,
        },
    };

</script>
